// extracted by mini-css-extract-plugin
export default {"page":"styles__page___hLJoa"};